import { useState } from "react";
import { CaretDown, CaretRight } from "@phosphor-icons/react";

// Sección colapsable para datos secundarios: cerrada muestra un resumen de una línea.
export default function Fold({ title, summary, icon: Icon, defaultOpen = false, testid, children, right }) {
  const [open, setOpen] = useState(defaultOpen);
  return (
    <section className="border border-zinc-200 rounded-md bg-white" data-testid={testid}>
      <div className="flex items-center gap-2 px-3 py-2">
        <button type="button" onClick={() => setOpen((v) => !v)} className="flex-1 min-w-0 flex items-center gap-2 text-left" data-testid={testid ? `${testid}-toggle` : undefined} aria-expanded={open}>
          {open ? <CaretDown size={11} weight="bold" className="text-zinc-500 shrink-0" /> : <CaretRight size={11} weight="bold" className="text-zinc-500 shrink-0" />}
          <span className="text-[10px] uppercase tracking-widest text-zinc-500 font-semibold inline-flex items-center gap-1 shrink-0">
            {Icon && <Icon size={11} weight="bold" />} {title}
          </span>
          {!open && summary && <span className="text-[11px] text-zinc-500 truncate flex-1 min-w-0" data-testid={testid ? `${testid}-summary` : undefined}>{summary}</span>}
          <span className="ml-auto text-[10px] text-zinc-400 shrink-0">{open ? "Ocultar" : "Ver"}</span>
        </button>
        {right}
      </div>
      {open && <div className="px-3 pb-3 space-y-4 border-t border-zinc-100 pt-3">{children}</div>}
    </section>
  );
}
